import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=5e88b12a&scoped=true&"
import script from "./DynamicList.vue?vue&type=script&lang=js&"
export * from "./DynamicList.vue?vue&type=script&lang=js&"
import style0 from "./DynamicList.vue?vue&type=style&index=0&id=5e88b12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88b12a",
  null
  
)

export default component.exports